export default __webpack_public_path__ + "a642d8a54736769cf292cd4dc79fbf23.png";